import React from "react"
import { ui } from "../styles/uiSystem"

export default function SectionCard({
  title,
  subtitle,
  actions = null,
  children,
  style = {},
  headerStyle = {},
  bodyStyle = {},
  compact = false
}) {
  const hasHeader = title || subtitle || actions

  return (
    <div
      style={{
        ...ui.card,
        padding: compact ? 12 : 14,
        ...style
      }}
    >
      {hasHeader ? (
        <div
          style={{
            ...ui.sectionHeader,
            marginBottom: compact ? 8 : 12,
            ...headerStyle
          }}
        >
          <div style={{ minWidth: 0 }}>
            {title ? <div style={ui.sectionTitle}>{title}</div> : null}
            {subtitle ? <div style={ui.sectionSubtitle}>{subtitle}</div> : null}
          </div>

          {actions ? <div>{actions}</div> : null}
        </div>
      ) : null}

      <div style={bodyStyle}>{children}</div>
    </div>
  )
}
